import React from 'react';
import { reduxForm, Field } from 'redux-form';

import { SelectInput } from '../SelectInput';
import { TagsService} from '../../services';
import i18next from "i18next";

class DeviceEditTagsForm extends React.Component {
  constructor(props) {
    super(props);

    // TODO handle pre-selected tags
    // TODO handle save

    this.state = {
      tagOptions: null
    };
  }

  componentDidMount() {
    this.refreshAvailableTags();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.deviceGrouping !== this.props.deviceGrouping) {
      this.refreshAvailableTags();
    }
  }

  mapTagOptions(tags) {
    return tags.sort((a, b) => {
      if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
      } else if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
      } else {
        return 0;
      }
    }).map(tag => ({label: tag.name, value: tag.id}));
  }

  refreshAvailableTags() {
    if (this.props.deviceGrouping && this.props.deviceId) {
      TagsService.listAvailableForDeviceAndGrouping(this.props.deviceGrouping.value, this.props.deviceId).then((response) => {
        this.setState({ tagOptions: this.mapTagOptions(response.tags)});
      }).catch((error) => {
        console.error(error);
        this.setState({ errorMessage: i18next.t('messages.could-not-load-tags-view') });
      });
    } else {
      TagsService.listAll().then((response) => {
        this.setState({ tagOptions: this.mapTagOptions(response.tags)});
      }).catch((error) => {
        console.error(error);
        this.setState({ errorMessage: i18next.t('messages.could-not-load-tags-view') });
      });
    }
  }

  render() {
    if (this.state.tagOptions) {
      return (
        <form className="tag-edit-form">
          <Field
            name="tags"
            options={this.state.tagOptions}
            component={SelectInput}
            isMulti
            onChange={this.props.onSelection}
          />
        </form>
      );
    } else {
      return (
        <div className="loader">{ i18next.t('loading') }</div>
      );
    }
  }
}

export default reduxForm({ form: 'DeviceEditTagsForm' })(DeviceEditTagsForm);
